export interface VisibleSelectionEntry {
	nodeId: string;
	actualIndex: number;
	displayOrder: number;
}

export function getVisibleSelectionEntries(
	unlockOrder: string[],
	visibleNodeIds: string[]
): VisibleSelectionEntry[] {
	return visibleNodeIds.flatMap((nodeId) => {
		const actualIndex = unlockOrder.indexOf(nodeId);
		if (actualIndex === -1) return [];

		return [{
			nodeId,
			actualIndex,
			displayOrder: actualIndex + 1
		}];
	});
}
